import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=ebfbef8e&scoped=true&"
var script = {}
import style0 from "./Description.vue?vue&type=style&index=0&id=ebfbef8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfbef8e",
  null
  
)

export default component.exports